import { useContext } from 'react';
import { BleepsManagerContext } from "../internal/BleepsManagerContext.js";
const defaultProps = {};
const useBleeps = (props = defaultProps) => {
    var _a;
    if (props.disabled) {
        return {};
    }
    const bleepsManager = useContext(BleepsManagerContext);
    return (_a = bleepsManager === null || bleepsManager === void 0 ? void 0 : bleepsManager.bleeps) !== null && _a !== void 0 ? _a : {};
};
export { useBleeps };
